// import React from "react";
// import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import {
//   Box,
//   Grid,
//   Card,
//   CardContent,
//   Typography,
//   Avatar,
//   LinearProgress,
//   Chip,
//   IconButton,
//   List,
//   ListItem,
//   ListItemAvatar,
//   ListItemText,
//   Divider,
// } from "@mui/material";
// import {
//   People,
//   School,
//   Assignment,
//   EventNote,
//   TrendingUp,
//   MoreVert,
//   CalendarMonth,
//   Notifications,
//   CheckCircle,
//   Schedule,
// } from "@mui/icons-material";
// import {
//   Chart as ChartJS,
//   ArcElement,
//   Tooltip,
//   Legend,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
// } from "chart.js";
// import { Doughnut, Line, Bar } from "react-chartjs-2";

// ChartJS.register(
//   ArcElement,
//   Tooltip,
//   Legend,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement
// );

// const Dashboard = () => {
//   const navigate = useNavigate();
//   const { user } = useSelector((state) => state.auth);
//   const userRole = user?.role?.slug || user?.role || "student";

//   // Sample data for charts
//   const attendanceData = {
//     labels: ["Present", "Absent", "Leave"],
//     datasets: [
//       {
//         data: [85, 10, 5],
//         backgroundColor: ["#4caf50", "#f44336", "#ff9800"],
//         borderWidth: 0,
//       },
//     ],
//   };

//   const performanceData = {
//     labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
//     datasets: [
//       {
//         label: "Performance",
//         data: [65, 70, 75, 72, 80, 85],
//         borderColor: "#1976d2",
//         backgroundColor: "rgba(25, 118, 210, 0.1)",
//         tension: 0.4,
//         fill: true,
//       },
//     ],
//   };

//   const assignmentData = {
//     labels: ["Mon", "Tue", "Wed", "Thu", "Fri"],
//     datasets: [
//       {
//         label: "Submitted",
//         data: [12, 19, 15, 17, 14],
//         backgroundColor: "#1976d2",
//       },
//       {
//         label: "Pending",
//         data: [5, 3, 8, 4, 6],
//         backgroundColor: "#ff9800",
//       },
//     ],
//   };

//   const stats = [
//     {
//       title: "Total Students",
//       value: "1,234",
//       change: "+12%",
//       icon: <People />,
//       color: "#1976d2",
//       roles: ["teacher", "hod", "admin", "superadmin"],
//       path: "/analytics/students",
//     },
//     {
//       title: "Total Teachers",
//       value: "89",
//       change: "+5%",
//       icon: <School />,
//       color: "#9c27b0",
//       roles: ["hod", "admin", "superadmin"],
//       path: "/analytics/teachers",
//     },
//     {
//       title: "Active Assignments",
//       value: "24",
//       change: "+8%",
//       icon: <Assignment />,
//       color: "#2e7d32",
//       roles: ["student", "teacher", "hod", "admin", "superadmin"],
//       path: "/analytics/assignments",
//     },
//     {
//       title: "Attendance Rate",
//       value: "92%",
//       change: "+3%",
//       icon: <EventNote />,
//       color: "#ed6c02",
//       roles: ["student", "teacher", "hod", "admin", "superadmin"],
//       path: "/analytics/attendance",
//     },
//     {
//       title: "Total Departments",
//       value: "12",
//       change: "0%",
//       icon: <School />,
//       color: "#0288d1",
//       roles: ["admin", "superadmin"],
//       path: "/analytics/departments",
//     },
//     {
//       title: "Total Institutes",
//       value: "5",
//       change: "+20%",
//       icon: <School />,
//       color: "#7b1fa2",
//       roles: ["superadmin"],
//       path: "/analytics/institutes",
//     },
//   ];

//   const upcomingEvents = [
//     { title: "Mid-term Exams", date: "Dec 20, 2025", type: "exam" },
//     { title: "Assignment Deadline", date: "Dec 18, 2025", type: "assignment" },
//     { title: "Parent-Teacher Meeting", date: "Dec 22, 2025", type: "meeting" },
//     { title: "Winter Break", date: "Dec 25, 2025", type: "holiday" },
//   ];

//   const recentActivities = [
//     {
//       title: "John submitted Physics Assignment",
//       time: "2 hours ago",
//       type: "assignment",
//     },
//     {
//       title: "New announcement posted",
//       time: "4 hours ago",
//       type: "notification",
//     },
//     {
//       title: "Attendance marked for Class 10A",
//       time: "5 hours ago",
//       type: "attendance",
//     },
//     {
//       title: "New material uploaded: Chemistry Notes",
//       time: "1 day ago",
//       type: "material",
//     },
//   ];

//   const filteredStats = stats.filter((stat) => stat.roles.includes(userRole));

//   return (
//     <Box>
//       {/* Welcome Section */}
//       <Box sx={{ mb: 4 }}>
//         <Typography variant="h4" fontWeight={600} gutterBottom>
//           Welcome back, {user?.firstName}! 👋
//         </Typography>
//         <Typography variant="body1" color="text.secondary">
//           Here's what's happening with your account today.
//         </Typography>
//       </Box>

//       {/* Stats Cards */}
//       <Grid container spacing={3} sx={{ mb: 4 }}>
//         {filteredStats.map((stat, index) => (
//           <Grid item xs={12} sm={6} md={3} key={index}>
//             <Card
//               sx={{
//                 height: "100%",
//                 cursor: "pointer",
//                 transition: "transform 0.2s, box-shadow 0.2s",
//                 "&:hover": {
//                   transform: "translateY(-4px)",
//                   boxShadow: 4,
//                 },
//               }}
//               onClick={() => stat.path && navigate(stat.path)}
//             >
//               <CardContent>
//                 <Box
//                   sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "flex-start",
//                   }}
//                 >
//                   <Box>
//                     <Typography
//                       variant="body2"
//                       color="text.secondary"
//                       gutterBottom
//                     >
//                       {stat.title}
//                     </Typography>
//                     <Typography variant="h4" fontWeight={700}>
//                       {stat.value}
//                     </Typography>
//                     <Chip
//                       label={stat.change}
//                       size="small"
//                       icon={<TrendingUp sx={{ fontSize: 14 }} />}
//                       sx={{
//                         mt: 1,
//                         bgcolor: stat.change.startsWith("+")
//                           ? "success.light"
//                           : "grey.200",
//                         color: stat.change.startsWith("+")
//                           ? "success.dark"
//                           : "text.secondary",
//                       }}
//                     />
//                   </Box>
//                   <Avatar sx={{ bgcolor: stat.color, width: 48, height: 48 }}>
//                     {stat.icon}
//                   </Avatar>
//                 </Box>
//               </CardContent>
//             </Card>
//           </Grid>
//         ))}
//       </Grid>

//       {/* Charts Row */}
//       <Grid container spacing={3} sx={{ mb: 4 }}>
//         {/* Attendance Chart */}
//         <Grid item xs={12} md={4}>
//           <Card
//             sx={{
//               height: "100%",
//               cursor: "pointer",
//               transition: "transform 0.2s, box-shadow 0.2s",
//               "&:hover": { transform: "translateY(-4px)", boxShadow: 4 },
//             }}
//             onClick={() => navigate("/analytics/attendance")}
//           >
//             <CardContent>
//               <Box
//                 sx={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   mb: 2,
//                 }}
//               >
//                 <Typography variant="h6" fontWeight={600}>
//                   Attendance Overview
//                 </Typography>
//                 <IconButton size="small">
//                   <MoreVert />
//                 </IconButton>
//               </Box>
//               <Box
//                 sx={{
//                   height: 250,
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//               >
//                 <Doughnut
//                   data={attendanceData}
//                   options={{
//                     responsive: true,
//                     maintainAspectRatio: false,
//                     plugins: { legend: { position: "bottom" } },
//                   }}
//                 />
//               </Box>
//             </CardContent>
//           </Card>
//         </Grid>

//         {/* Performance Chart */}
//         <Grid item xs={12} md={8}>
//           <Card
//             sx={{
//               height: "100%",
//               cursor: "pointer",
//               transition: "transform 0.2s, box-shadow 0.2s",
//               "&:hover": { transform: "translateY(-4px)", boxShadow: 4 },
//             }}
//             onClick={() => navigate("/analytics/attendance")}
//           >
//             <CardContent>
//               <Box
//                 sx={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   mb: 2,
//                 }}
//               >
//                 <Typography variant="h6" fontWeight={600}>
//                   Performance Trend
//                 </Typography>
//                 <IconButton size="small">
//                   <MoreVert />
//                 </IconButton>
//               </Box>
//               <Box sx={{ height: 250 }}>
//                 <Line
//                   data={performanceData}
//                   options={{
//                     responsive: true,
//                     maintainAspectRatio: false,
//                     plugins: { legend: { display: false } },
//                     scales: {
//                       y: { beginAtZero: true, max: 100 },
//                     },
//                   }}
//                 />
//               </Box>
//             </CardContent>
//           </Card>
//         </Grid>
//       </Grid>

//       {/* Bottom Row */}
//       <Grid container spacing={3}>
//         {/* Assignment Stats */}
//         <Grid item xs={12} md={8}>
//           <Card
//             sx={{
//               cursor: "pointer",
//               transition: "transform 0.2s, box-shadow 0.2s",
//               "&:hover": { transform: "translateY(-4px)", boxShadow: 4 },
//             }}
//             onClick={() => navigate("/analytics/assignments")}
//           >
//             <CardContent>
//               <Box
//                 sx={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   mb: 2,
//                 }}
//               >
//                 <Typography variant="h6" fontWeight={600}>
//                   Assignment Statistics
//                 </Typography>
//                 <IconButton size="small">
//                   <MoreVert />
//                 </IconButton>
//               </Box>
//               <Box sx={{ height: 280 }}>
//                 <Bar
//                   data={assignmentData}
//                   options={{
//                     responsive: true,
//                     maintainAspectRatio: false,
//                     plugins: { legend: { position: "top" } },
//                   }}
//                 />
//               </Box>
//             </CardContent>
//           </Card>
//         </Grid>

//         {/* Upcoming Events */}
//         <Grid item xs={12} md={4}>
//           <Card sx={{ height: "100%" }}>
//             <CardContent>
//               <Box
//                 sx={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   mb: 2,
//                 }}
//               >
//                 <Typography variant="h6" fontWeight={600}>
//                   Upcoming Events
//                 </Typography>
//                 <CalendarMonth color="action" />
//               </Box>
//               <List disablePadding>
//                 {upcomingEvents.map((event, index) => (
//                   <React.Fragment key={index}>
//                     <ListItem disablePadding sx={{ py: 1.5 }}>
//                       <ListItemAvatar>
//                         <Avatar
//                           sx={{
//                             width: 36,
//                             height: 36,
//                             bgcolor:
//                               event.type === "exam"
//                                 ? "error.light"
//                                 : event.type === "assignment"
//                                 ? "warning.light"
//                                 : event.type === "meeting"
//                                 ? "info.light"
//                                 : "success.light",
//                           }}
//                         >
//                           {event.type === "exam" ? (
//                             <Assignment sx={{ fontSize: 18 }} />
//                           ) : event.type === "assignment" ? (
//                             <Schedule sx={{ fontSize: 18 }} />
//                           ) : (
//                             <CalendarMonth sx={{ fontSize: 18 }} />
//                           )}
//                         </Avatar>
//                       </ListItemAvatar>
//                       <ListItemText
//                         primary={event.title}
//                         secondary={event.date}
//                         primaryTypographyProps={{
//                           variant: "body2",
//                           fontWeight: 500,
//                         }}
//                         secondaryTypographyProps={{ variant: "caption" }}
//                       />
//                     </ListItem>
//                     {index < upcomingEvents.length - 1 && <Divider />}
//                   </React.Fragment>
//                 ))}
//               </List>
//             </CardContent>
//           </Card>
//         </Grid>

//         {/* Recent Activities */}
//         <Grid item xs={12}>
//           <Card>
//             <CardContent>
//               <Box
//                 sx={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   mb: 2,
//                 }}
//               >
//                 <Typography variant="h6" fontWeight={600}>
//                   Recent Activities
//                 </Typography>
//                 <Notifications color="action" />
//               </Box>
//               <List disablePadding>
//                 {recentActivities.map((activity, index) => (
//                   <React.Fragment key={index}>
//                     <ListItem disablePadding sx={{ py: 1.5 }}>
//                       <ListItemAvatar>
//                         <Avatar
//                           sx={{
//                             width: 36,
//                             height: 36,
//                             bgcolor: "primary.light",
//                           }}
//                         >
//                           <CheckCircle sx={{ fontSize: 18 }} />
//                         </Avatar>
//                       </ListItemAvatar>
//                       <ListItemText
//                         primary={activity.title}
//                         secondary={activity.time}
//                         primaryTypographyProps={{ variant: "body2" }}
//                         secondaryTypographyProps={{ variant: "caption" }}
//                       />
//                     </ListItem>
//                     {index < recentActivities.length - 1 && <Divider />}
//                   </React.Fragment>
//                 ))}
//               </List>
//             </CardContent>
//           </Card>
//         </Grid>
//       </Grid>
//     </Box>
//   );
// };

// export default Dashboard;


import React, { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { DATE_DISPLAY_FORMAT, toApiDate } from "../../utils/dateUtils";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Avatar,
  Box,
  Backdrop,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip as MuiTooltip,
  Typography,
  Skeleton,
} from "@mui/material";
import {
  Assignment,
  Download,
  ExpandMore,
  People,
  School,
} from "@mui/icons-material";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import dashboardService from "../../services/dashboardService";
import analyticsService from "../../services/analyticsService";
import advancedReportService from "../../services/advancedReportService";
import courseService from "../../services/courseService";
import classSubjectService from "../../services/classSubjectService";
import RecentActivitiesCard from "../../components/dashboard/RecentActivitiesCard";
import { usePermissions } from "../../hooks/usePermissions";
ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement
);
 
const STAT_DEFINITIONS = [
  {
    key: "totalStudents",
    title: "Total Students",
    valuePath: "totalStudents",
    changePath: "totalStudentsChange",
    icon: <People />,
    color: "#1976d2",
    roles: ["student", "teacher", "hod", "admin", "superadmin"],
    path: "/analytics/students",
    rolePaths: {
      student: "/student/students",
      teacher: "/teacher/students",
      hod: "/hod/students",
      admin: "/admin/students",
      // Super admin: go to global students analytics list
      superadmin: "/analytics/students",
    },
    // Allow showing based on permission too (for custom roles)
    permission: "student.profile.read",
  },
  {
    key: "totalTeachers",
    title: "Total Teachers",
    valuePath: "totalTeachers",
    changePath: "totalTeachersChange",
    icon: <School />,
    color: "#9c27b0",
    roles: ["hod", "admin", "superadmin"],
    path: "/analytics/teachers",
    rolePaths: {
      hod: "/hod/teachers",
      admin: "/admin/teachers", 
      // Super admin: go to global teachers analytics list
      superadmin: "/analytics/teachers",
    },
    permission: "teacher.profile.read",
  },
  {
    key: "totalAssignments",
    title: "Total Assignments",
    valuePath: "totalAssignments",
    changePath: "totalAssignmentsChange",
    icon: <Assignment />,
    color: "#2e7d32",
    roles: ["student", "teacher", "hod", "admin"],
    // path: "/analytics/assignments",
    rolePaths: {
      student: "/student/assignments",
      teacher: "/teacher/assignments",
      hod: "/hod/assignments",
      admin: "/admin/assignments",
    },
  },
  {
    key: "totalCourses",
    title: "Total Courses",
    valuePath: "totalCourses",
    changePath: "activeCoursesChange",
    icon: <Assignment />,
    color: "#1565c0",
    roles: ["student", "admin", "superadmin"],
    // path: "/analytics/courses",
    rolePaths: {
      student: "/student/courses",
      admin: "/admin/courses",
      superadmin: "/superadmin/courses",
    },
    defaultValue: "—",
    defaultChange: "+0%",
    permission: "course.read",
  },
  /* Attendance Rate stat - commented out
  {
    key: "attendanceRate",
    title: "Attendance Rate",
    valuePath: "attendanceRate",
    changePath: "attendanceRateChange",
    icon: <EventNote />,
    color: "#ed6c02",
    roles: ["student", "teacher", "hod", "admin", "superadmin"],
    // path: "/analytics/attendance",
    rolePaths: {
      student: "/student/attendance",
      teacher: "/teacher/attendance",
      hod: "/hod/attendance",
      admin: "/admin/attendance",
      superadmin: "/superadmin/attendance",
    },
    formatOptions: { isPercentage: true },
  },
  */
  {
    key: "totalDepartments",
    title: "Total Departments",
    valuePath: "totalDepartments",
    changePath: "totalDepartmentsChange",
    icon: <School />,
    color: "#0288d1",
    roles: ["admin", "superadmin"],
    path: "/analytics/departments",
    rolePaths: {
      admin: "/admin/departments",
      // Super admin: go to global departments analytics list
      superadmin: "/analytics/departments",
    },
    permission: "department.read",
  },
  {
    key: "totalInstitutes",
    title: "Total Institutes",
    valuePath: "totalInstitutes",
    changePath: "totalInstitutesChange",
    icon: <School />,
    color: "#7b1fa2",
    roles: ["superadmin"],
    path: "/analytics/institutes",
    rolePaths: {
      superadmin: "/superadmin/institutes",
    },
  },
  /* Upcoming Events stat - commented out
  {
    key: "upcomingEvents",
    title: "Upcoming Events",
    valuePath: "upcomingEventsCount",
    changePath: "upcomingEventsChange",
    icon: <EventNote />,
    color: "#ff7043",
    roles: ["student", "superadmin"],
    // path: "/analytics/events",
    rolePaths: {
      student: "/student/timetable",
      superadmin: "/superadmin/events",
    },
    defaultValue: "—",
    defaultChange: "+0%",
  },
  */
];
 
const getValueFromPath = (source, path) => {
  if (!source || !path) return undefined;
  return path.split(".").reduce((acc, key) => {
    if (acc && Object.prototype.hasOwnProperty.call(acc, key)) {
      return acc[key];
    }
    return undefined;
  }, source);
};
 
const getStatPathForRole = (definition, role) => {
  if (!definition) return null;
  return definition.rolePaths?.[role] || definition.path || null;
};
 
const formatStatValue = (value, options = {}) => {
  const { isPercentage = false, fractionDigits = 0 } = options;
 
  if (value === null || value === undefined) {
    return "-";
  }
 
  if (typeof value === "number") {
    let numericValue = value;
    if (isPercentage && numericValue <= 1) {
      numericValue *= 100;
    }
 
    const formatted = numericValue.toLocaleString(undefined, {
      maximumFractionDigits: fractionDigits,
      minimumFractionDigits: fractionDigits,
    });
 
    return isPercentage ? `${formatted}%` : formatted;
  }
 
  if (typeof value === "string") {
    return value;
  }
 
  return `${value}`;
};
 
const formatChangeLabel = (change) => {
  if (change === null || change === undefined) {
    return "+0%";
  }
 
  if (typeof change === "number") {
    const prefix = change >= 0 ? "+" : "";
    return `${prefix}${change}%`;
  }
 
  if (typeof change === "string") {
    const trimmed = change.trim();
 
    if (!trimmed) {
      return "+0%";
    }
 
    const hasSign = /^[+-]/.test(trimmed);
    const hasPercent = trimmed.endsWith("%");
 
    return `${hasSign ? "" : "+"}${trimmed}${hasPercent ? "" : "%"}`;
  }
 
  return "+0%";
};
 
// Normalize role for stats filtering and API (e.g. "Super Admin" / "super admin" -> "superadmin")
const normalizeRoleForDashboard = (role) => {
  if (!role) return "student";
  const s = String(role?.slug ?? role).toLowerCase().trim();
  if (s === "institute") return "admin";
  if (s === "super admin" || s === "superadmin") return "superadmin";
  return s.replace(/\s+/g, "");
};

function debugDashboard(...args) {
  try {
    if (typeof window === "undefined") return;
    const qs = new URLSearchParams(window.location.search || "");
    const enabled =
      window?.localStorage?.getItem("debugDashboard") === "1" ||
      window?.sessionStorage?.getItem("debugDashboard") === "1" ||
      qs.get("debugDashboard") === "1" ||
      qs.get("debug") === "1";
    if (!enabled) return;
    // eslint-disable-next-line no-console
    console.log(...args);
  } catch {
    // ignore (private mode / blocked storage)
  }
}

/** One row per teacher; subjects deduped and comma-separated (avoids duplicate teacher lines on class cards). */
function groupFacultyByTeacher(faculty) {
  if (!Array.isArray(faculty) || faculty.length === 0) return [];
  const byTeacher = new Map();
  for (const f of faculty) {
    const teacher = String(f?.teacher ?? f?.teacherName ?? "Unknown").trim() || "Unknown";
    const subject = String(f?.subject ?? f?.subjectName ?? "").trim();
    if (!byTeacher.has(teacher)) byTeacher.set(teacher, new Set());
    if (subject) byTeacher.get(teacher).add(subject);
  }
  return Array.from(byTeacher.entries()).map(([teacher, subjectSet]) => ({
    teacher,
    subjects: Array.from(subjectSet).sort((a, b) => a.localeCompare(b)),
  }));
}

function logReportPreviewAlways(...args) {
  // Keep this lightweight: only in dev, and only for the report preview flow.
  if (process.env.NODE_ENV !== "development") return;
  // eslint-disable-next-line no-console
  console.log("[reportPreview]", ...args);
}

function pick(obj, paths = []) {
  const out = {};
  for (const p of paths) out[p] = getValueFromPath(obj, p);
  return out;
}

/** Unwrap GET /analytics/dashboard-stats body (tolerate proxies / odd nesting). */
function getDashboardStatsPayload(res) {
  const root = res?.data;
  debugDashboard("[dashboard preview] unwrap input", { hasRes: !!res, rootKeys: root && typeof root === "object" ? Object.keys(root) : null });
  if (root == null) return null;
  const looksLikeInner = (o) =>
    o &&
    typeof o === "object" &&
    ("stats" in o || "dashboard" in o || "studentFormatted" in o || "filter" in o);
  if (looksLikeInner(root)) return root;
  if (root.data && looksLikeInner(root.data)) return root.data;
  if (root.data?.data && looksLikeInner(root.data.data)) return root.data.data;
  return root.data ?? null;
}

/** When backend omits studentFormatted but still returns dashboard.student + dashboard.reports (e.g. scope service returned null). */
function studentPreviewFromDashboardStats(inner) {
  const dash = inner?.dashboard;
  if (!dash || typeof dash !== "object") return null;
  const st = dash.student;
  if (!st || typeof st !== "object") return null;
  if (st.id == null && !st.name && (st.rollNo == null || st.rollNo === "")) return null;

  const rep = dash.reports || {};
  const rc = rep.reportCard || {};
  const sid =
    st.rollNo != null && st.rollNo !== ""
      ? String(st.rollNo)
      : st.id != null && st.id !== ""
        ? String(st.id)
        : "";

  const subjectsRaw = Array.isArray(rc.subjects) ? rc.subjects : [];
  const reportCardSubjects = subjectsRaw.map((r) => ({
    subject: r.subject || "—",
    marksObtained: r.obtained ?? r.marksObtained ?? 0,
    totalMarks: r.fullMarks ?? r.totalMarks ?? 0,
    attempt: r.attempt ?? 1,
    status: r.result || r.status || "—",
  }));

  const spArr = Array.isArray(rep.subjectPerformance) ? rep.subjectPerformance : [];
  const subjectPerformance = {
    selectedView: inner?.filter || "monthly",
    availableViews: ["daily", "weekly", "monthly"],
    subjects: spArr.map((s) => ({
      subject: s.subject || "—",
      totalMarksPercentage: s.totalMarksPercent ?? s.totalMarksPercentage ?? 0,
      attendancePercentage: s.totalAttendancePercent ?? s.attendancePercentage ?? 0,
      overallPerformance: s.overallPercent ?? s.overallPerformance ?? 0,
    })),
  };

  const points = rep.percentageGraph?.points || [];
  const graphLabel = (t) => {
    const x = String(t || "").toLowerCase();
    if (x === "unittest") return "Monthly Test";
    if (x === "final") return "Annual Exam";
    if (x === "midterm") return "Mid Term";
    if (x === "quiz") return "Quiz";
    return String(t || "—");
  };
  const percentageGraph = points.map((p) => ({
    label: graphLabel(p.examType),
    percentage: p.percent ?? p.percentage ?? 0,
  }));

  const monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
  const monthly = Array.isArray(rep.performanceAnalytics?.monthly) ? rep.performanceAnalytics.monthly : [];
  const monthlyPerformance = monthly.map((row) => {
    const key = row.month || "";
    const mo = /^\d{4}-(\d{2})$/.exec(key);
    const idx = mo ? Number.parseInt(mo[1], 10) - 1 : 0;
    const marksP = row.marksPercent;
    const attP = row.attendancePercent;
    const val =
      marksP == null && attP == null
        ? 0
        : marksP == null
          ? attP
          : attP == null
            ? marksP
            : Math.round((Number(marksP) + Number(attP)) / 2);
    return { month: monthNames[idx] || "—", percentage: Number(val) || 0 };
  });

  const examMonthLabel =
    inner?.period?.startDate && inner?.period?.endDate
      ? `${inner.period.startDate} – ${inner.period.endDate}`
      : "—";

  return {
    studentId: sid,
    studentName: st.name || "—",
    academicYear: null,
    personalReport: {
      examType: rc.examType || inner?.examType || "—",
      examMonth: examMonthLabel,
      percentageGraph,
      subjects: reportCardSubjects,
    },
    subjectPerformance,
    performanceAnalytics: {
      year: rep.performanceAnalytics?.year ?? inner?.year,
      monthlyPerformance,
    },
    performanceCompression: {
      selectedMonth: "—",
      previous: { attendancePercentage: 0, totalMarks: 0, outOf: 0 },
      current: { attendancePercentage: 0, totalMarks: 0, outOf: 0 },
    },
    classCompression: {
      yours: { attendancePercentage: 0, totalMarks: 0, outOf: 0 },
      class: { attendancePercentage: 0, totalMarks: 0, outOf: 0 },
    },
    reportCard: {
      examType: rc.examType || inner?.examType,
      examMonth: examMonthLabel,
      viewFilter: inner?.filter || "monthly",
      availableViews: ["daily", "weekly", "monthly"],
      subjects: reportCardSubjects,
    },
  };
}

function studentPreviewFromDashboardStatsOrStats(inner, fallbackStudent) {
  const fromDash = studentPreviewFromDashboardStats(inner);
  if (fromDash) return fromDash;

  // Fallback: endpoint returned stats but no dashboard.student (common for institute role)
  if (!inner || typeof inner !== "object") return null;
  if (!inner.stats || typeof inner.stats !== "object") return null;

  const examMonthLabel =
    inner?.period?.startDate && inner?.period?.endDate
      ? `${inner.period.startDate} – ${inner.period.endDate}`
      : inner?.examMonth || "—";

  const sid =
    fallbackStudent?.studentId != null && fallbackStudent.studentId !== ""
      ? String(fallbackStudent.studentId)
      : fallbackStudent?.id != null && fallbackStudent.id !== ""
        ? String(fallbackStudent.id)
        : "";

  const sname =
    fallbackStudent?.name ||
    fallbackStudent?.studentName ||
    fallbackStudent?.fullName ||
    "—";

  return {
    studentId: sid,
    studentName: sname,
    academicYear: null,
    personalReport: {
      examType: inner?.examType || "—",
      examMonth: examMonthLabel,
      percentageGraph: [],
      subjects: [],
    },
    subjectPerformance: {
      selectedView: inner?.filter || "monthly",
      availableViews: ["daily", "weekly", "monthly"],
      subjects: [],
    },
    performanceAnalytics: {
      year: inner?.year,
      monthlyPerformance: [],
    },
    performanceCompression: {
      selectedMonth: "—",
      previous: { attendancePercentage: 0, totalMarks: 0, outOf: 0 },
      current: { attendancePercentage: 0, totalMarks: 0, outOf: 0 },
    },
    classCompression: {
      yours: { attendancePercentage: 0, totalMarks: 0, outOf: 0 },
      class: { attendancePercentage: 0, totalMarks: 0, outOf: 0 },
    },
    reportCard: {
      examType: inner?.examType,
      examMonth: examMonthLabel,
      viewFilter: inner?.filter || "monthly",
      availableViews: ["daily", "weekly", "monthly"],
      subjects: [],
    },
    dashboardStats: inner.stats,
  };
}

const Dashboard = () => {
  const { hasVisiblePermission } = usePermissions();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const { isInInstituteContext, selectedInstitute } = useSelector((state) => state.instituteContext);
  const rawUserRole = user?.role?.slug || user?.role || "student";
  const userRole = normalizeRoleForDashboard(rawUserRole);
  // When superadmin is in institute context, use admin stats; after sign-out use superadmin stats
  const effectiveRole = (userRole === "superadmin" && isInInstituteContext) ? "admin" : userRole;
  /** Institute-scoped dashboard widgets (institute admin, super admin, or HOD viewing their department) */
  const showAdminDepartmentWidgets =
    userRole === "superadmin" || effectiveRole === "admin" || effectiveRole === "hod";

  const [dashboardStats, setDashboardStats] = useState(null);
  const [loadingStats, setLoadingStats] = useState(false);
  const [statsError, setStatsError] = useState(null);

  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  // Date filter for teacher dashboard: year, from, to
  const year = searchParams.get("year") || String(new Date().getFullYear());
  const fromDate = searchParams.get("from") || `${year}-01-01`;
  const toDate = searchParams.get("to") || `${year}-12-31`;

  const examMonthForReports = useMemo(() => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const rawMonth = searchParams.get("month");
    const m = rawMonth != null && rawMonth !== "" ? Number.parseInt(String(rawMonth), 10) : NaN;
    const y = Number.parseInt(String(year), 10);
    if (Number.isFinite(m) && m >= 1 && m <= 12 && Number.isFinite(y)) {
      return `${monthNames[m - 1]} ${y}`;
    }
    const d = new Date();
    return `${d.toLocaleString(undefined, { month: "long" })} ${d.getFullYear()}`;
  }, [searchParams, year]);

  const handleDateFilterChange = (key, value) => {
    const next = new URLSearchParams(searchParams);
    if (value) next.set(key, value);
    else next.delete(key);
    setSearchParams(next);
  };

  useEffect(() => {
    if (location.pathname !== "/dashboard") return;

    let isSubscribed = true;

    const fetchStats = async () => {
      setLoadingStats(true);
      try {
        let response;
        const dateParams = { year, from: fromDate, to: toDate };
        if (effectiveRole === "teacher") {
          response = await dashboardService.getTeacherStats(dateParams);
        } else if (effectiveRole === "admin" || effectiveRole === "hod") {
          response = await dashboardService.getInstituteStats(dateParams);
        } else {
          response = await dashboardService.getAdminStats(dateParams);
        }
 
        if (!isSubscribed) return;
 
        const payload = response?.data ?? {};
        const normalizedData =
          payload?.data && typeof payload.data === "object"
            ? payload.data
            : payload;
 
        setDashboardStats(normalizedData);
        setStatsError(null);
      } catch (error) {
        if (!isSubscribed) return;
 
        const message =
          error?.response?.data?.message ||
          error?.message ||
          "Failed to load dashboard statistics.";
        setStatsError(message);
        setDashboardStats(null);
      } finally {
        if (isSubscribed) {
          setLoadingStats(false);
        }
      }
    };
 
    fetchStats();
 
    return () => {
      isSubscribed = false;
    };
  }, [effectiveRole, location.pathname, year, fromDate, toDate]);
 
  // ============ HOD/TEACHER: Class-wise student data ============
  const [classWiseData, setClassWiseData] = useState([]);
  const [hodDepartmentName, setHodDepartmentName] = useState("");
  const [classWiseLoading, setClassWiseLoading] = useState(false);
  const [exportClassId, setExportClassId] = useState("");
  const [exporting, setExporting] = useState(false);

  useEffect(() => {
    if ((effectiveRole !== "hod" && effectiveRole !== "teacher") || location.pathname !== "/dashboard") return;
    let active = true;
    const fetch = async () => {
      setClassWiseLoading(true);
      try {
        const res =
          effectiveRole === "hod"
            ? await dashboardService.getHodClassWiseStudents()
            : await dashboardService.getTeacherClassWiseStudents();
        if (active) {
          const payload = res?.data?.data;
          setHodDepartmentName(payload?.department ?? payload?.teacher ?? "");
          setClassWiseData(Array.isArray(payload?.classes) ? payload.classes : []);
        }
      } catch (e) {
        console.warn("Failed to load class-wise data", e);
      } finally {
        if (active) setClassWiseLoading(false);
      }
    };
    fetch();
    return () => { active = false; };
  }, [effectiveRole, location.pathname]);

  /** Class filter (dropdown): narrows dashboard cards; same value used when exporting roster CSV. */
  const displayedClassWiseRows = useMemo(() => {
    if (exportClassId === "" || exportClassId == null) return classWiseData;
    const want = String(exportClassId);
    return classWiseData.filter((c) => String(c.classId) === want);
  }, [classWiseData, exportClassId]);

  const handleExportRoster = async () => {
    setExporting(true);
    try {
      const res = await dashboardService.exportHodClassRoster(
        exportClassId ? { classId: String(exportClassId) } : {}
      );
      const csvData = res?.data?.csvData;
      if (csvData) {
        const blob = new Blob([csvData], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = res?.data?.fileName || "class_roster_export.csv";
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }
    } catch (e) {
      console.warn("Export failed", e);
    } finally {
      setExporting(false);
    }
  };

  // ============ ADMIN: Department distribution ============
  const [deptDistribution, setDeptDistribution] = useState([]);
  const [deptDistLoading, setDeptDistLoading] = useState(false);
  const [institutesForFilter, setInstitutesForFilter] = useState([]);
  const [institutePickerId, setInstitutePickerId] = useState(null);
  const [departmentFilterId, setDepartmentFilterId] = useState("all");
  const [drilldownExporting, setDrilldownExporting] = useState(false);
  const [classesSpecialExporting, setClassesSpecialExporting] = useState(false);
  const [departmentsTypeExporting, setDepartmentsTypeExporting] = useState(false);

  // ============ ADMIN: Drill-down classes per department ============
  const [expandedDept, setExpandedDept] = useState(null);
  const [deptClasses, setDeptClasses] = useState({});
  const [deptClassesLoading, setDeptClassesLoading] = useState({});

  // ============ Drill-down: Students per class ============
  const [studentsDialogOpen, setStudentsDialogOpen] = useState(false);
  const [studentsDialogClass, setStudentsDialogClass] = useState(null);
  const [studentsLoading, setStudentsLoading] = useState(false);
  const [studentsRows, setStudentsRows] = useState([]);
  const [studentsSearchQuery, setStudentsSearchQuery] = useState("");
  const [teacherLectureStatsRows, setTeacherLectureStatsRows] = useState([]);
  const [teacherLectureStatsLoading, setTeacherLectureStatsLoading] = useState(false);
  const [teacherLectureStatsView, setTeacherLectureStatsView] = useState("daily");
  const [teacherLectureClassFilter, setTeacherLectureClassFilter] = useState("");
  const [teacherLectureSubjectFilter, setTeacherLectureSubjectFilter] = useState("");
  const [teacherLectureSubjectOptions, setTeacherLectureSubjectOptions] = useState([]);
  const [teacherLectureSubjectsLoading, setTeacherLectureSubjectsLoading] = useState(false);
  const [teacherLectureClassOptions, setTeacherLectureClassOptions] = useState([]);
  const [teacherLectureClassesLoading, setTeacherLectureClassesLoading] = useState(false);
  const [teacherLectureFromDate, setTeacherLectureFromDate] = useState(null);
  const [teacherLectureToDate, setTeacherLectureToDate] = useState(null);
  const [teacherLectureExporting, setTeacherLectureExporting] = useState(false);
  const [studentDownloadLoadingId, setStudentDownloadLoadingId] = useState(null);
  const [studentPreviewLoadingId, setStudentPreviewLoadingId] = useState(null);
  const [reportPreviewOpen, setReportPreviewOpen] = useState(false);
  const [reportPreviewData, setReportPreviewData] = useState(null);
  const [reportPreviewLoading, setReportPreviewLoading] = useState(false);
  const reportPreviewRequestSeq = useRef(0);
  const activeReportPreviewStudentIdRef = useRef(null);

  // ============ ADMIN: Attendance heatmap ============
  const [heatmapData, setHeatmapData] = useState({ weeks: [], departments: [] });
  const [heatmapLoading, setHeatmapLoading] = useState(false);
  const [heatmapWeeks, setHeatmapWeeks] = useState(4);

  const effectiveInstituteIdForWidgets = useMemo(() => {
    const fromUser = user?.instituteId;
    if (fromUser != null && fromUser !== "") return Number(fromUser);
    if (selectedInstitute?.id) return selectedInstitute.id;
    if (userRole === "superadmin" && institutePickerId) return institutePickerId;
    return null;
  }, [user?.instituteId, selectedInstitute?.id, userRole, institutePickerId]);

  const filteredDeptDistribution = useMemo(() => {
    if (departmentFilterId === "all") return deptDistribution;
    const id = Number(departmentFilterId);
    return deptDistribution.filter((d) => d.id === id);
  }, [deptDistribution, departmentFilterId]);

  useEffect(() => {
    if (userRole !== "superadmin" || location.pathname !== "/dashboard") return;
    let active = true;
    const load = async () => {
      try {
        const res = await dashboardService.getDashboardInstitutesForFilter();
        const list = res?.data?.data?.institutes ?? [];
        if (!active) return;
        setInstitutesForFilter(list);
        setInstitutePickerId((prev) => {
          if (prev != null) return prev;
          if (selectedInstitute?.id) return selectedInstitute.id;
          if (list.length) return list[0].id;
          return null;
        });
      } catch (e) {
        console.warn("Failed to load institutes for filter", e);
      }
    };
    load();
    return () => {
      active = false;
    };
  }, [userRole, location.pathname, selectedInstitute?.id]);

  useEffect(() => {
    if (!showAdminDepartmentWidgets || location.pathname !== "/dashboard") return;
    if (!effectiveInstituteIdForWidgets) return;
    let active = true;
    const fetch = async () => {
      setDeptDistLoading(true);
      try {
        const res = await dashboardService.getAdminDepartmentDistribution({
          instituteId: effectiveInstituteIdForWidgets,
        });
        if (active) setDeptDistribution(res?.data?.data?.departments ?? []);
      } catch (e) {
        console.warn("Failed to load dept distribution", e);
      } finally {
        if (active) setDeptDistLoading(false);
      }
    };
    fetch();
    return () => {
      active = false;
    };
  }, [showAdminDepartmentWidgets, location.pathname, effectiveInstituteIdForWidgets]);

  useEffect(() => {
    setDeptClasses({});
    setExpandedDept(null);
  }, [effectiveInstituteIdForWidgets, departmentFilterId]);

  // Auto-set department filter for HODs to their own department
  useEffect(() => {
    if (effectiveRole !== "hod") return;
    if (!deptDistribution.length) return;
    // Backend already scopes to HOD's department, so there should be exactly one entry
    const hodDept = deptDistribution[0];
    if (hodDept?.id && departmentFilterId === "all") {
      setDepartmentFilterId(Number(hodDept.id));
    }
  }, [effectiveRole, deptDistribution, departmentFilterId]);

  useEffect(() => {
    if (!showAdminDepartmentWidgets || location.pathname !== "/dashboard") return;
    if (!effectiveInstituteIdForWidgets) return;
    let active = true;
    const fetch = async () => {
      setHeatmapLoading(true);
      try {
        const params = {
          weeks: heatmapWeeks,
          instituteId: effectiveInstituteIdForWidgets,
          ...(departmentFilterId !== "all" ? { departmentId: departmentFilterId } : {}),
        };
        const res = await dashboardService.getAdminAttendanceHeatmap(params);
        if (active) setHeatmapData(res?.data?.data ?? { weeks: [], departments: [] });
      } catch (e) {
        console.warn("Failed to load heatmap", e);
      } finally {
        if (active) setHeatmapLoading(false);
      }
    };
    fetch();
    return () => {
      active = false;
    };
  }, [showAdminDepartmentWidgets, location.pathname, heatmapWeeks, effectiveInstituteIdForWidgets, departmentFilterId]);

  const downloadCsvFromResponse = (res, fallbackFileName) => {
    const csvData = res?.data?.csvData;
    if (!csvData) return;
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = res?.data?.fileName || fallbackFileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  const loadTeacherLectureStats = async () => {
    // Only for institute/admin/superadmin dashboards. Teacher/HOD personal stats already come from /analytics/dashboard-stats.
    if (!effectiveInstituteIdForWidgets) return;
    if (!showAdminDepartmentWidgets) return;
    setTeacherLectureStatsLoading(true);
    try {
      const fromApi = teacherLectureFromDate ? toApiDate(teacherLectureFromDate) : null;
      const toApi = teacherLectureToDate ? toApiDate(teacherLectureToDate) : null;
      const res = await analyticsService.getTeacherLectureStats({
        instituteId: effectiveInstituteIdForWidgets,
        ...(departmentFilterId !== "all" ? { departmentId: departmentFilterId } : {}),
        ...(teacherLectureClassFilter ? { classId: teacherLectureClassFilter } : {}),
        ...(teacherLectureSubjectFilter ? { subjectId: teacherLectureSubjectFilter } : {}),
        viewFilter: teacherLectureStatsView,
        ...(fromApi && toApi ? { from: fromApi, to: toApi } : {}),
      });
      const rows = res?.data?.data?.rows ?? [];
      setTeacherLectureStatsRows(Array.isArray(rows) ? rows : []);
    } catch (e) {
      console.warn("Failed to load teacher lecture stats", e);
      setTeacherLectureStatsRows([]);
    } finally {
      setTeacherLectureStatsLoading(false);
    }
  };

  useEffect(() => {
    void loadTeacherLectureStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    effectiveInstituteIdForWidgets,
    departmentFilterId,
    showAdminDepartmentWidgets,
    teacherLectureStatsView,
    teacherLectureClassFilter,
    teacherLectureSubjectFilter,
    teacherLectureFromDate,
    teacherLectureToDate,
  ]);

  const handleExportTeacherLectureStats = async () => {
    if (!effectiveInstituteIdForWidgets) return;
    const fromApi = teacherLectureFromDate ? toApiDate(teacherLectureFromDate) : null;
    const toApi = teacherLectureToDate ? toApiDate(teacherLectureToDate) : null;
    if ((fromApi && !toApi) || (!fromApi && toApi)) return;
    setTeacherLectureExporting(true);
    try {
      const res = await analyticsService.exportTeacherLectureStats({
        instituteId: effectiveInstituteIdForWidgets,
        ...(departmentFilterId !== "all" ? { departmentId: departmentFilterId } : {}),
        ...(teacherLectureClassFilter ? { classId: teacherLectureClassFilter } : {}),
        ...(teacherLectureSubjectFilter ? { subjectId: teacherLectureSubjectFilter } : {}),
        viewFilter: teacherLectureStatsView,
        ...(fromApi && toApi ? { from: fromApi, to: toApi } : {}),
      });
      downloadCsvFromResponse(res, "teacher_lecture_statistics.csv");
    } catch (e) {
      console.warn("Teacher lecture stats export failed", e);
    } finally {
      setTeacherLectureExporting(false);
    }
  };

  useEffect(() => {
    if (!showAdminDepartmentWidgets || !effectiveInstituteIdForWidgets) {
      setTeacherLectureClassOptions([]);
      return;
    }
    let active = true;
    const loadClasses = async () => {
      setTeacherLectureClassesLoading(true);
      try {
        let list = [];
        if (departmentFilterId !== "all") {
          const res = await dashboardService.getAdminDepartmentClasses(departmentFilterId, {
            instituteId: effectiveInstituteIdForWidgets,
          });
          list = res?.data?.data ?? [];
        } else {
          const res = await courseService.getClasses({
            instituteId: effectiveInstituteIdForWidgets,
            page: 1,
            limit: 500,
          });
          list = res?.data?.data ?? [];
        }
        if (!active) return;
        const normalized = (Array.isArray(list) ? list : []).map((c) => {
          const classId = c.classId ?? c.id;
          const name = c.className ?? c.name ?? `Class ${classId}`;
          const section = c.section ?? "";
          return {
            classId,
            className: section ? `${name} - ${section}` : name,
          };
        });
        setTeacherLectureClassOptions(normalized);
        if (
          teacherLectureClassFilter &&
          !normalized.some((c) => String(c.classId) === String(teacherLectureClassFilter))
        ) {
          setTeacherLectureClassFilter("");
          setTeacherLectureSubjectFilter("");
        }
      } catch (e) {
        console.warn("Failed to load classes for teacher lecture filters", e);
        if (active) setTeacherLectureClassOptions([]);
      } finally {
        if (active) setTeacherLectureClassesLoading(false);
      }
    };
    loadClasses();
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAdminDepartmentWidgets, effectiveInstituteIdForWidgets, departmentFilterId]);

  useEffect(() => {
    if (!teacherLectureClassFilter) {
      setTeacherLectureSubjectOptions([]);
      setTeacherLectureSubjectFilter("");
      return;
    }
    let active = true;
    const loadSubjects = async () => {
      setTeacherLectureSubjectsLoading(true);
      try {
        const res = await classSubjectService.getSubjectsByClass(teacherLectureClassFilter);
        const list = res?.data?.data?.subjects ?? [];
        if (!active) return;
        setTeacherLectureSubjectOptions(Array.isArray(list) ? list : []);
      } catch {
        if (active) setTeacherLectureSubjectOptions([]);
      } finally {
        if (active) setTeacherLectureSubjectsLoading(false);
      }
    };
    loadSubjects();
    return () => {
      active = false;
    };
  }, [teacherLectureClassFilter]);

  const handleExportDrilldown = async () => {
    if (!effectiveInstituteIdForWidgets) return;
    setDrilldownExporting(true);
    try {
      const res = await dashboardService.exportAdminDepartmentDrilldown({
        instituteId: effectiveInstituteIdForWidgets,
        ...(departmentFilterId !== "all" ? { departmentId: departmentFilterId } : {}),
      });
      downloadCsvFromResponse(res, "department_drilldown_export.csv");
    } catch (e) {
      console.warn("Drill-down export failed", e);
    } finally {
      setDrilldownExporting(false);
    }
  };

  const handleExportClassesSpecial = async () => {
    if (!effectiveInstituteIdForWidgets) return;
    setClassesSpecialExporting(true);
    try {
      const res = await dashboardService.exportAdminClassesSpecial({
        instituteId: effectiveInstituteIdForWidgets,
        ...(departmentFilterId !== "all" ? { departmentId: departmentFilterId } : {}),
      });
      downloadCsvFromResponse(res, "classes_special_report.csv");
    } catch (e) {
      console.warn("Class special export failed", e);
    } finally {
      setClassesSpecialExporting(false);
    }
  };

  const handleExportDepartmentsType = async () => {
    if (!effectiveInstituteIdForWidgets) return;
    setDepartmentsTypeExporting(true);
    try {
      const res = await dashboardService.exportAdminDepartmentsType({
        instituteId: effectiveInstituteIdForWidgets,
        ...(departmentFilterId !== "all" ? { departmentId: departmentFilterId } : {}),
      });
      downloadCsvFromResponse(res, "departments_type_report.csv");
    } catch (e) {
      console.warn("Department type export failed", e);
    } finally {
      setDepartmentsTypeExporting(false);
    }
  };

  const handleAccordionChange = (deptId) => async (_, isExpanded) => {
    setExpandedDept(isExpanded ? deptId : null);
    if (!effectiveInstituteIdForWidgets) return;
    if (isExpanded && !deptClasses[deptId]) {
      setDeptClassesLoading((p) => ({ ...p, [deptId]: true }));
      try {
        const res = await dashboardService.getAdminDepartmentClasses(deptId, {
          instituteId: effectiveInstituteIdForWidgets,
          includeStudents: true,
          studentsLimit: 200,
        });
        setDeptClasses((p) => ({ ...p, [deptId]: res?.data?.data ?? [] }));
      } catch (e) {
        console.warn("Failed to load dept classes", e);
      } finally {
        setDeptClassesLoading((p) => ({ ...p, [deptId]: false }));
      }
    }
  };

  const openStudentsDialog = async (cls) => {
    setStudentsDialogClass(cls);
    setStudentsDialogOpen(true);
    setStudentsSearchQuery("");

    // Prefer embedded list from drill-down API (fast, no extra call)
    if (Array.isArray(cls?.students) && cls.students.length) {
      setStudentsRows(cls.students);
      setStudentsLoading(false);
      return;
    }

    setStudentsRows([]);
    setStudentsLoading(true);
    try {
      const res = await analyticsService.getStudents({
        classId: cls.classId,
        page: 1,
        limit: 1000,
      });
      const list = res?.data?.data ?? [];
      // Normalize to dialog shape
      const normalized = (Array.isArray(list) ? list : []).map((s) => ({
        id: s.id,
        studentId: s.studentId || s.student_id || "",
        rollNumber: s.rollNumber ?? s.roll_number ?? "",
        rollNo: s.rollNumber ?? s.roll_number ?? s.rollNo ?? "",
        name: s.name || s.fullName || `${s.firstName || ""} ${s.lastName || ""}`.trim() || null,
        email: s.email || null,
      }));
      setStudentsRows(normalized);
    } catch (e) {
      console.warn("Failed to load students for class", e);
      setStudentsRows([]);
    } finally {
      setStudentsLoading(false);
    }
  };

  const filteredStudentsRows = useMemo(() => {
    const q = (studentsSearchQuery || "").trim().toLowerCase();
    if (!q) return studentsRows;
    return studentsRows.filter((s) => {
      const name = String(s.name || "").toLowerCase();
      const roll = String(s.rollNumber || s.rollNo || "").toLowerCase();
      const sid = String(s.studentId || "").toLowerCase();
      return name.includes(q) || roll.includes(q) || sid.includes(q);
    });
  }, [studentsRows, studentsSearchQuery]);

  const handleDownloadStudentReport = async (row) => {
    const studentId =
      row?.id != null && row?.id !== "" ? row.id : row?.studentId || row?.rollNo || row?.id;
    if (studentId == null || studentId === "") return;
    const loadingKey = String(row?.id ?? studentId);
    setStudentDownloadLoadingId(loadingKey);
    try {
      const examMonth = examMonthForReports;
      const res = await advancedReportService.requestStudentReportDownload({
        studentId,
        examType: "final",
        examMonth,
        viewFilter: "monthly",
        ...(effectiveInstituteIdForWidgets ? { instituteId: effectiveInstituteIdForWidgets } : {}),
      });
      const blob = res?.data;
      if (blob) {
        const url = window.URL.createObjectURL(blob);
        const a=document.createElement("a");
        a.href=url;
        a.download=`student_report_${studentId}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(()=>window.URL.revokeObjectURL(url),60_000);
      }
    } catch (e) {
      console.warn("Student report download failed", e);
    } finally {
      setStudentDownloadLoadingId(null);
    }
  };

  const handlePreviewStudentReport = async (row) => {
    const studentId =
      row?.id != null && row?.id !== "" ? row.id : row?.studentId || row?.rollNo || row?.id;

    if (studentId == null || studentId === "") return;
    const studentKey = String(studentId);
    const loadingKey = String(row?.id ?? studentKey);
    logReportPreviewAlways("handlePreviewStudentReport:start", { row, studentId, studentKey });
    const mySeq = (Number(reportPreviewRequestSeq.current) || 0) + 1;
    reportPreviewRequestSeq.current = mySeq;
    activeReportPreviewStudentIdRef.current = studentKey;
    setStudentPreviewLoadingId(loadingKey);
    setReportPreviewData(null);
    setReportPreviewOpen(true);
    setReportPreviewLoading(true);
    try {
      const examMonth = examMonthForReports;
      // Use the same API mobile uses (dashboard studentFormatted payload)
      debugDashboard("[dashboard preview] request params", {
        studentId: studentKey,
        examType: "final",
        examMonth,
        viewFilter: "monthly",
        instituteId: effectiveInstituteIdForWidgets ?? null,
      });
      const res = await analyticsService.getDashboardStats({
        studentId: studentKey,
        examType: "final",
        examMonth,
        viewFilter: "monthly",
        ...(effectiveInstituteIdForWidgets ? { instituteId: effectiveInstituteIdForWidgets } : {}),
      });
      logReportPreviewAlways("handlePreviewStudentReport:response", {
        studentKey,
        status: res?.status,
        hasData: !!res?.data,
      });
      // If the user opened another preview while this request was in-flight, ignore this response.
      if (activeReportPreviewStudentIdRef.current !== studentKey) {
        debugDashboard("[dashboard preview] stale response discarded (student changed)", {
          expectedStudentId: activeReportPreviewStudentIdRef.current,
          responseStudentId: studentKey,
          mySeq,
          currentSeq: reportPreviewRequestSeq.current,
        });
        logReportPreviewAlways("handlePreviewStudentReport:stale-discarded", {
          expectedStudentId: activeReportPreviewStudentIdRef.current,
          responseStudentId: studentKey,
        });
        return;
      }

      const inner = getDashboardStatsPayload(res);
      debugDashboard("[dashboard preview] raw response", res?.data);
      debugDashboard("[dashboard preview] normalized payload", inner);
      let preview =
        inner?.studentFormatted ??
        studentPreviewFromDashboardStatsOrStats(inner, row) ??
        null;
      // Always attach dashboard stats so preview matches API numbers (even when studentFormatted exists)
      if (preview && inner?.stats && !preview.dashboardStats) {
        preview = { ...preview, dashboardStats: inner.stats };
      }
      debugDashboard("[dashboard preview] computed preview", preview);
      debugDashboard(
        "[dashboard preview] stats snapshot",
        pick(inner, [
          "filter",
          "examType",
          "period.startDate",
          "period.endDate",
          "stats.hours.totalHours",
          "stats.hours.totalLectures",
          "stats.assignments.totalAssignments",
          "stats.attendance.totalMarked",
          "stats.attendance.presentCount",
          "stats.attendance.attendanceRate",
          "stats.attendance.overall.percent",
          "dashboard.role",
        ])
      );
      setReportPreviewData(preview);
      logReportPreviewAlways("handlePreviewStudentReport:applied", {
        studentKey,
        hasPreview: !!preview,
        hasDashboardStats: !!preview?.dashboardStats,
      });
    } catch (e) {
      console.warn("Student report preview failed", e);
      logReportPreviewAlways("handlePreviewStudentReport:error", { studentKey, message: e?.message });
      if (activeReportPreviewStudentIdRef.current === studentKey) {
        setReportPreviewData(null);
      }
    } finally {
      if (activeReportPreviewStudentIdRef.current === studentKey) {
        setStudentPreviewLoadingId(null);
        setReportPreviewLoading(false);
      }
      logReportPreviewAlways("handlePreviewStudentReport:finally", { studentKey });
    }
  };

  useEffect(() => {
    debugDashboard("[dashboard preview] state reportPreviewData changed", reportPreviewData);
    if (reportPreviewData?.dashboardStats) {
      debugDashboard("[dashboard preview] rendered values", {
        totalHours: reportPreviewData.dashboardStats?.hours?.totalHours ?? 0,
        totalLectures: reportPreviewData.dashboardStats?.hours?.totalLectures ?? 0,
        totalAssignments: reportPreviewData.dashboardStats?.assignments?.totalAssignments ?? 0,
        attendanceRate:
          reportPreviewData.dashboardStats?.attendance?.attendanceRate ??
          reportPreviewData.dashboardStats?.attendance?.overall?.percent ??
          0,
        totalMarked: reportPreviewData.dashboardStats?.attendance?.totalMarked ?? 0,
        presentCount: reportPreviewData.dashboardStats?.attendance?.presentCount ?? 0,
      });
    }
  }, [reportPreviewData]);

  const getHeatmapColor = (rate) => {
    if (rate === null || rate === undefined) return "#f5f5f5";
    if (rate >= 85) return "#c8e6c9";
    if (rate >= 70) return "#fff9c4";
    return "#ffcdd2";
  };

  // Distribution bar chart data
  const distributionChartData = useMemo(() => {
    if (!filteredDeptDistribution.length) return null;
    return {
      labels: filteredDeptDistribution.map((d) => d.name),
      datasets: [
        {
          label: "Students",
          data: filteredDeptDistribution.map((d) => d.studentCount),
          backgroundColor: "#1976d2",
        },
        {
          label: "Teachers",
          data: filteredDeptDistribution.map((d) => d.teacherCount),
          backgroundColor: "#9c27b0",
        },
      ],
    };
  }, [filteredDeptDistribution]);

  const stats = useMemo(() => {
    return STAT_DEFINITIONS.map((definition) => {
      const rawValue =
        (definition.valueGetter &&
          definition.valueGetter(dashboardStats, definition)) ??
        getValueFromPath(dashboardStats, definition.valuePath);
 
      const rawChange =
        (definition.changeGetter &&
          definition.changeGetter(dashboardStats, definition)) ??
        getValueFromPath(dashboardStats, definition.changePath);
 
      return {
        ...definition,
        // Used to hide permission-only cards when API doesn't provide the value (prevents "-" / "—" cards)
        hasRawValue: rawValue !== undefined && rawValue !== null,
        value: formatStatValue(
          rawValue !== undefined ? rawValue : definition.defaultValue,
          definition.formatOptions
        ),
        change: formatChangeLabel(
          rawChange !== undefined ? rawChange : definition.defaultChange
        ),
      };
    });
  }, [dashboardStats]);
 
  const filteredStats = useMemo(() => {
    return stats
      .filter((stat) => {
        if (stat.roles.includes(effectiveRole)) return true;
        if (stat.permission && hasVisiblePermission(stat.permission)) {
          // Only show permission-based cards when the stats payload actually contains that value
          return Boolean(stat.hasRawValue);
        }
        return false;
      })
      .map((stat) => ({
        ...stat,
        // Use userRole for path so it matches actual routes (e.g. /superadmin/students for superadmin)
        resolvedPath: getStatPathForRole(stat, userRole),
      }));
  }, [stats, effectiveRole, userRole, hasVisiblePermission]);
 
  const isStatsLoading = loadingStats && !dashboardStats;

  return (
    <Box>
      {/* Welcome Section */}
      <Box sx={{ mb: 4 }}>
        <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: 2 }}>
          <Box>
            <Typography variant="h4" fontWeight={600} gutterBottom>
              Welcome back, {user?.firstName}! 👋
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Here's what's happening with your account today.
            </Typography>
          </Box>
          {/* Date filter for teacher dashboard */}
          {effectiveRole === "teacher" && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
              <TextField
                size="small"
                label="Year"
                type="text"
                value={year}
                onChange={(e) => {
                  const v = String(e.target.value || "")
                    .replace(/[^\d]/g, "")
                    .slice(0, 4);
                  handleDateFilterChange("year", v);
                }}
                inputProps={{
                  inputMode: "numeric",
                  pattern: "\\d{4}",
                  maxLength: 4,
                  min: 2020,
                  max: 2030,
                }}
                sx={{ width: 90 }}
              />
              <DatePicker
                label="From"
                format={DATE_DISPLAY_FORMAT}
                value={fromDate ? new Date(fromDate) : null}
                onChange={(val) => handleDateFilterChange("from", toApiDate(val))}
                slotProps={{
                  textField: {
                    size: "small",
                    sx: { width: 150 },
                  },
                }}
              />
              <DatePicker
                label="To"
                format={DATE_DISPLAY_FORMAT}
                value={toDate ? new Date(toDate) : null}
                onChange={(val) => handleDateFilterChange("to", toApiDate(val))}
                slotProps={{
                  textField: {
                    size: "small",
                    sx: { width: 150 },
                  },
                }}
              />
              <Button
                size="small"
                variant="outlined"
                onClick={() => {
                  handleDateFilterChange("from", "");
                  handleDateFilterChange("to", "");
                }}
                disabled={!fromDate && !toDate}
              >
                Clear
              </Button>
            </Box>
          )}
        </Box>
      </Box>
 
      {/* Stats Cards */}
      <Box sx={{ mb: 2 }}>
        {isStatsLoading && <LinearProgress sx={{ mb: 2 }} />}
        {statsError && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {statsError}
          </Alert>
        )}
      </Box>
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {isStatsLoading ? (
          Array.from({
            length: Math.max(filteredStats.length, 4),
          }).map((_, i) => (
            <Grid item xs={12} sm={6} md={3} key={`dash-stat-sk-${i}`}>
              <Card sx={{ height: "100%" }}>
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    <Box sx={{ flex: 1 }}>
                      <Skeleton variant="text" width="70%" height={20} sx={{ mb: 1 }} />
                      <Skeleton variant="text" width="50%" height={40} />
                    </Box>
                    <Skeleton variant="circular" width={48} height={48} />
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))
        ) : filteredStats.length > 0 ? (
          filteredStats.map((stat) => {
            // For superadmin dashboard, keep cards informational only (not clickable)
            const isClickable =
              userRole !== "superadmin" && Boolean(stat.resolvedPath);
            return (
            <Grid item xs={12} sm={6} md={3} key={stat.key}>
              <Card
                sx={{
                  height: "100%",
                  cursor: isClickable ? "pointer" : "default",
                  transition: "transform 0.2s, box-shadow 0.2s",
                  "&:hover":
                    isClickable
                      ? {
                          transform: "translateY(-4px)",
                          boxShadow: 4,
                        }
                      : {},
                }}
                onClick={() => isClickable && navigate(stat.resolvedPath)}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    <Box>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        gutterBottom
                      >
                        {stat.title}
                      </Typography>
                      <Typography variant="h4" fontWeight={700}>
                        {stat.value}
                      </Typography>
                      {/* Green +0% change chip - commented out
                      <Chip
                        label={stat.change}
                        size="small"
                        icon={<TrendingUp sx={{ fontSize: 14 }} />}
                        sx={{
                          mt: 1,
                          bgcolor: stat.change.startsWith("+")
                            ? "success.light"
                            : "grey.200",
                          color: stat.change.startsWith("+")
                            ? "success.dark"
                            : "text.secondary",
                        }}
                      />
                      */}
                    </Box>
                    <Avatar sx={{ bgcolor: stat.color, width: 48, height: 48 }}>
                      {stat.icon}
                    </Avatar>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            );
          })
        ) : (
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <Typography align="center" color="text.secondary">
                  No statistics available for your role.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>

      {/* ============ HOD/TEACHER: Class-Wise Student Count ============ */}
      {(effectiveRole === "hod" || effectiveRole === "teacher") && (
        <Box sx={{ mb: 4 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, flexWrap: "wrap", gap: 1 }}>
            <Box>
              <Typography variant="h6" fontWeight={600}>
                Class-wise Student Count
              </Typography>
              {hodDepartmentName ? (
                <Typography variant="body2" color="text.secondary">
                  {effectiveRole === "hod" ? "Department" : "Teacher"}: {hodDepartmentName}
                </Typography>
              ) : null}
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel>Class Filter</InputLabel>
                <Select
                  value={exportClassId === "" || exportClassId == null ? "" : String(exportClassId)}
                  label="Class Filter"
                  onChange={(e) => setExportClassId(e.target.value)}
                >
                  <MenuItem value="">
                    All Classes
                  </MenuItem>
                  {classWiseData.map((c) => (
                    <MenuItem key={c.classId} value={String(c.classId)}>
                      {c.className} {c.section ? `- ${c.section}` : ""}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Button
                variant="outlined"
                size="small"
                startIcon={exporting ? <CircularProgress size={16} /> : <Download />}
                onClick={handleExportRoster}
                disabled={exporting}
              >
                {exporting ? "Exporting…" : "Export Roster"}
              </Button>
            </Box>
          </Box>
          {classWiseLoading ? (
            <>
              <LinearProgress sx={{ mb: 2 }} />
              <Grid container spacing={2}>
                {[0, 1, 2, 3].map((i) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={`hod-class-sk-${i}`}>
                    <Card sx={{ height: "100%" }}>
                      <CardContent>
                        <Skeleton variant="text" width="75%" height={28} sx={{ mb: 1 }} />
                        <Skeleton variant="text" width="50%" height={18} sx={{ mb: 1 }} />
                        <Skeleton variant="text" width="90%" height={16} />
                        <Skeleton variant="text" width="40%" height={40} sx={{ mt: 2 }} />
                        <Skeleton variant="rounded" width="100%" height={6} sx={{ mt: 1 }} />
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </>
          ) : (
            <Grid container spacing={2}>
              {displayedClassWiseRows.map((cls) => {
                const studentCount = cls.students ?? cls.studentCount ?? 0;
                const fillPct = cls.capacity > 0 ? Math.min(100, Math.round((studentCount / cls.capacity) * 100)) : 0;
                const facultyGrouped = groupFacultyByTeacher(cls.faculty);
                return (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={cls.classId}>
                    <Card
                      sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <CardContent
                        sx={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          pb: 2,
                          "&:last-child": { pb: 2 },
                        }}
                      >
                        <Typography variant="subtitle1" fontWeight={600} noWrap title={`${cls.className}${cls.section ? ` - ${cls.section}` : ""}`}>
                          {cls.className} {cls.section ? `- ${cls.section}` : ""}
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5, fontWeight: 600 }}>
                          Faculty / Subjects
                          {facultyGrouped.length > 0 ? ` (${facultyGrouped.length})` : ""}
                        </Typography>
                        {facultyGrouped.length > 0 ? (
                          <Box
                            sx={{
                              mt: 0.5,
                              mb: 1,
                              maxHeight: 120,
                              overflowY: "auto",
                              pr: 0.5,
                              flexShrink: 0,
                            }}
                          >
                            {facultyGrouped.map((row) => (
                              <Box key={row.teacher} sx={{ mb: 0.75, "&:last-child": { mb: 0 } }}>
                                <Typography variant="caption" fontWeight={600} color="text.primary" display="block" noWrap title={row.teacher}>
                                  {row.teacher}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                  display="block"
                                  sx={{ lineHeight: 1.35 }}
                                  title={row.subjects.join(", ")}
                                >
                                  {row.subjects.join(", ")}
                                </Typography>
                              </Box>
                            ))}
                          </Box>
                        ) : (
                          <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5, mb: 1 }}>
                            No subject assignments yet.
                          </Typography>
                        )}
                        <Box sx={{ mt: "auto", pt: 0.5 }}>
                          <Typography variant="h4" fontWeight={700}>
                            {studentCount}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            of {cls.capacity} capacity
                          </Typography>
                          <LinearProgress
                            variant="determinate"
                            value={fillPct}
                            sx={{
                              mt: 1,
                              height: 6,
                              borderRadius: 3,
                              bgcolor: "grey.200",
                              "& .MuiLinearProgress-bar": {
                                bgcolor: fillPct > 90 ? "error.main" : fillPct > 70 ? "warning.main" : "primary.main",
                              },
                            }}
                          />
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })}
              {classWiseData.length === 0 && (
                <Grid item xs={12}>
                  <Typography color="text.secondary" align="center">
                    {effectiveRole === "hod"
                      ? "No classes found in your department."
                      : "No classes linked to your timetable, homeroom, or subject assignments yet."}
                  </Typography>
                </Grid>
              )}
              {classWiseData.length > 0 && displayedClassWiseRows.length === 0 && (
                <Grid item xs={12}>
                  <Typography color="text.secondary" align="center">
                    No class matches the selected filter.
                  </Typography>
                </Grid>
              )}
            </Grid>
          )}
        </Box>
      )}

      {/* ============ ADMIN / INSTITUTE: Teacher lecture statistics (mobile parity) ============ */}
      {showAdminDepartmentWidgets && userRole !== "superadmin" && effectiveInstituteIdForWidgets && (
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" fontWeight={600} sx={{ mb: 0.5 }}>
            Teacher Lecture Statistics
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center", gap: 1, mb: 2 }}>
            <Typography variant="body2" color="text.secondary">
              Compare attended vs scheduled lectures and hours by teacher for the selected scope.
            </Typography>
            <Button
              variant="outlined"
              size="small"
              startIcon={teacherLectureExporting ? <CircularProgress size={16} /> : <Download />}
              disabled={teacherLectureExporting || teacherLectureStatsLoading}
              onClick={handleExportTeacherLectureStats}
            >
              {teacherLectureExporting ? "Exporting…" : "Export"}
            </Button>
          </Box>

          <Card variant="outlined" sx={{ mb: 2, bgcolor: "grey.50" }}>
            <CardContent sx={{ py: 2, "&:last-child": { pb: 2 } }}>
              <Grid container spacing={2} alignItems="flex-end">
                <Grid item xs={12} sm={6} md={2}>
                  <DatePicker
                    label="From Date"
                    format={DATE_DISPLAY_FORMAT}
                    value={teacherLectureFromDate}
                    onChange={(val) => setTeacherLectureFromDate(val)}
                    slotProps={{ textField: { size: "small", fullWidth: true } }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <DatePicker
                    label="To Date"
                    format={DATE_DISPLAY_FORMAT}
                    value={teacherLectureToDate}
                    minDate={teacherLectureFromDate || undefined}
                    onChange={(val) => setTeacherLectureToDate(val)}
                    slotProps={{ textField: { size: "small", fullWidth: true } }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="tl-stats-view-label">View</InputLabel>
                    <Select
                      labelId="tl-stats-view-label"
                      label="View"
                      value={teacherLectureStatsView}
                      onChange={(e) => setTeacherLectureStatsView(String(e.target.value || "daily"))}
                    >
                      <MenuItem value="daily">Daily</MenuItem>
                      <MenuItem value="weekly">Weekly</MenuItem>
                      <MenuItem value="monthly">Monthly</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <FormControl fullWidth size="small" disabled={!deptDistribution.length}>
                    <InputLabel id="tl-stats-dept-label">Department</InputLabel>
                    <Select
                      labelId="tl-stats-dept-label"
                      label="Department"
                      value={departmentFilterId === "all" ? "all" : String(departmentFilterId)}
                      onChange={(e) => {
                        const v = e.target.value;
                        setDepartmentFilterId(v === "all" ? "all" : Number(v));
                        setTeacherLectureClassFilter("");
                        setTeacherLectureSubjectFilter("");
                      }}
                    >
                      <MenuItem value="all">All departments</MenuItem>
                      {deptDistribution.map((d) => (
                        <MenuItem key={d.id} value={String(d.id)}>
                          {d.name}
                          {d.hodName ? ` — HOD: ${d.hodName}` : ""}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <FormControl fullWidth size="small" disabled={teacherLectureClassesLoading}>
                    <InputLabel id="tl-stats-class-label">Class</InputLabel>
                    <Select
                      labelId="tl-stats-class-label"
                      label="Class"
                      value={teacherLectureClassFilter}
                      onChange={(e) => {
                        setTeacherLectureClassFilter(String(e.target.value || ""));
                        setTeacherLectureSubjectFilter("");
                      }}
                    >
                      <MenuItem value="">All classes</MenuItem>
                      {teacherLectureClassOptions.map((c) => (
                        <MenuItem key={String(c.classId)} value={String(c.classId)}>
                          {c.className || `Class ${c.classId}`}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <FormControl
                    fullWidth
                    size="small"
                    disabled={!teacherLectureClassFilter || teacherLectureSubjectsLoading}
                  >
                    <InputLabel id="tl-stats-subject-label">Subject</InputLabel>
                    <Select
                      labelId="tl-stats-subject-label"
                      label="Subject"
                      value={teacherLectureSubjectFilter}
                      onChange={(e) => setTeacherLectureSubjectFilter(String(e.target.value || ""))}
                    >
                      <MenuItem value="">All subjects</MenuItem>
                      {teacherLectureSubjectsLoading ? (
                        <MenuItem disabled>Loading…</MenuItem>
                      ) : (
                        teacherLectureSubjectOptions.map((s) => (
                          <MenuItem key={String(s.id)} value={String(s.id)}>
                            {s.name || s.subjectName || `Subject ${s.id}`}
                          </MenuItem>
                        ))
                      )}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {teacherLectureStatsLoading ? (
            <Box>
              <LinearProgress sx={{ mb: 2, borderRadius: 1 }} />
              <Card>
                <CardContent>
                  <Skeleton variant="rectangular" height={280} sx={{ borderRadius: 1 }} />
                </CardContent>
              </Card>
            </Box>
          ) : (
            <Card>
              <CardContent sx={{ pt: 2 }}>
                <TableContainer sx={{ maxHeight: 420 }}>
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600 }}>Teacher</TableCell>
                        <TableCell align="right" sx={{ fontWeight: 600 }}>
                          Attended / Total Lectures
                        </TableCell>
                        <TableCell align="right" sx={{ fontWeight: 600 }}>
                          Attended / Total Hours
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(teacherLectureStatsRows || []).map((r) => (
                        <TableRow key={String(r.teacherId)} hover>
                          <TableCell>{r.teacherName || `Teacher #${r.teacherId}`}</TableCell>
                          <TableCell align="right">
                            {Number(r.attended?.lectures || 0)}/{Number(r.scheduled?.totalLectures || 0)}
                          </TableCell>
                          <TableCell align="right">
                            {Number(r.attended?.hours || 0)}/{Number(r.scheduled?.totalHours || 0)}
                          </TableCell>
                        </TableRow>
                      ))}
                      {(!teacherLectureStatsRows || teacherLectureStatsRows.length === 0) && (
                        <TableRow>
                          <TableCell colSpan={3} align="center" sx={{ py: 4, color: "text.secondary" }}>
                            No teachers found for the selected scope.
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>
          )}
        </Box>
      )}

      {/* ============ ADMIN / SUPER ADMIN: Department Distribution (Macro View) ============ */}
      {showAdminDepartmentWidgets && (
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
            Department Distribution
          </Typography>
          {userRole === "superadmin" && !isInInstituteContext && (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 2, alignItems: "center" }}>
              <FormControl size="small" sx={{ minWidth: 260 }}>
                <InputLabel>College / Institute</InputLabel>
                <Select
                  label="College / Institute"
                  value={institutePickerId ?? ""}
                  onChange={(e) => setInstitutePickerId(e.target.value ? Number(e.target.value) : null)}
                >
                  {institutesForFilter.map((i) => (
                    <MenuItem key={i.id} value={i.id}>
                      {i.name}
                      {i.instituteCode ? ` (${i.instituteCode})` : ""}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          )}
          {!effectiveInstituteIdForWidgets && userRole === "superadmin" && !isInInstituteContext && (
            <Alert severity="info" sx={{ mb: 2 }}>
              Select a college to load department data.
            </Alert>
          )}
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 2, alignItems: "center" }}>
            <FormControl size="small" sx={{ minWidth: 280 }} disabled={!deptDistribution.length || effectiveRole === "hod"}>
              <InputLabel>Department / HOD</InputLabel>
              <Select
                label="Department / HOD"
                value={departmentFilterId === "all" ? "all" : String(departmentFilterId)}
                onChange={(e) => {
                  const v = e.target.value;
                  setDepartmentFilterId(v === "all" ? "all" : Number(v));
                }}
              >
                {effectiveRole !== "hod" && <MenuItem value="all">All departments</MenuItem>}
                {deptDistribution.map((d) => (
                  <MenuItem key={d.id} value={String(d.id)}>
                    {d.name}
                    {d.hodName ? ` — HOD: ${d.hodName}` : ""}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              variant="outlined"
              size="small"
              startIcon={drilldownExporting ? <CircularProgress size={16} /> : <Download />}
              onClick={handleExportDrilldown}
              disabled={!effectiveInstituteIdForWidgets || drilldownExporting || !deptDistribution.length}
            >
              {drilldownExporting ? "Downloading…" : "Download report"}
            </Button>
            <Button
              variant="outlined"
              size="small"
              startIcon={classesSpecialExporting ? <CircularProgress size={16} /> : <Download />}
              onClick={handleExportClassesSpecial}
              disabled={!effectiveInstituteIdForWidgets || classesSpecialExporting}
            >
              {classesSpecialExporting ? "Exporting…" : "Class special"}
            </Button>
            <Button
              variant="outlined"
              size="small"
              startIcon={departmentsTypeExporting ? <CircularProgress size={16} /> : <Download />}
              onClick={handleExportDepartmentsType}
              disabled={!effectiveInstituteIdForWidgets || departmentsTypeExporting}
            >
              {departmentsTypeExporting ? "Exporting…" : "Department type"}
            </Button>
          </Box>
          {deptDistLoading ? (
            <>
              <LinearProgress sx={{ mb: 2 }} />
              <Grid container spacing={3}>
                <Grid item xs={12} md={7}>
                  <Card>
                    <CardContent>
                      <Skeleton variant="text" width="40%" height={28} sx={{ mb: 2 }} />
                      <Skeleton variant="rounded" height={300} />
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} md={5}>
                  <Card>
                    <CardContent>
                      <Skeleton variant="text" width="55%" height={28} sx={{ mb: 2 }} />
                      <Skeleton variant="rounded" height={260} />
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </>
          ) : (
            <Grid container spacing={3}>
              {/* Bar Chart */}
              {distributionChartData && (
                <Grid item xs={12} md={7}>
                  <Card>
                    <CardContent>
                      <Box sx={{ height: 300 }}>
                        <Bar
                          data={distributionChartData}
                          options={{
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: { legend: { position: "top" } },
                            scales: { y: { beginAtZero: true } },
                          }}
                        />
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              )}
              {/* Summary Table */}
              <Grid item xs={12} md={distributionChartData ? 5 : 12}>
                <Card>
                  <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
                    <TableContainer sx={{ maxHeight: 360, overflowY: "auto" }}>
                      <Table size="small" stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell><strong>Department</strong></TableCell>
                            <TableCell align="right"><strong>Students</strong></TableCell>
                            <TableCell align="right"><strong>Teachers</strong></TableCell>
                            <TableCell align="right"><strong>Classes</strong></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {filteredDeptDistribution.map((d) => (
                            <TableRow key={d.id} hover>
                              <TableCell>
                                {d.name}
                                {d.hodName ? (
                                  <Typography component="span" variant="caption" color="text.secondary" display="block">
                                    HOD: {d.hodName}
                                  </Typography>
                                ) : null}
                              </TableCell>
                              <TableCell align="right">{d.studentCount}</TableCell>
                              <TableCell align="right">{d.teacherCount}</TableCell>
                              <TableCell align="right">{d.classCount}</TableCell>
                            </TableRow>
                          ))}
                          {filteredDeptDistribution.length === 0 && (
                            <TableRow>
                              <TableCell colSpan={4} align="center">No departments found.</TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          )}
        </Box>
      )}

      {/* ============ ADMIN / SUPER ADMIN: Drill-Down (Micro View) ============ */}
      {showAdminDepartmentWidgets && filteredDeptDistribution.length > 0 && (
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
            Department Drill-Down
          </Typography>
          {filteredDeptDistribution.map((dept) => (
            <Accordion
              key={dept.id}
              expanded={expandedDept === dept.id}
              onChange={handleAccordionChange(dept.id)}
              sx={{ mb: 1 }}
            >
              <AccordionSummary expandIcon={<ExpandMore />}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2, width: "100%", flexWrap: "wrap" }}>
                  <Typography fontWeight={600}>{dept.name}</Typography>
                  {dept.hodName ? (
                    <Chip label={`HOD: ${dept.hodName}`} size="small" color="secondary" variant="outlined" />
                  ) : null}
                  <Chip label={`${dept.teacherCount ?? 0} teachers`} size="small" variant="outlined" />
                  <Chip label={`${dept.studentCount} students`} size="small" color="primary" variant="outlined" />
                  <Chip label={`${dept.classCount} classes`} size="small" variant="outlined" />
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                {deptClassesLoading[dept.id] ? (
                  <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
                    <CircularProgress size={24} />
                  </Box>
                ) : (
                  <TableContainer sx={{ maxHeight: 420, overflowY: "auto" }}>
                    <Table size="small" stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell><strong>Class</strong></TableCell>
                          <TableCell><strong>Section</strong></TableCell>
                          <TableCell align="right"><strong>Students</strong></TableCell>
                          <TableCell align="right"><strong>Capacity</strong></TableCell>
                          <TableCell><strong>Faculty / Subjects</strong></TableCell>
                          <TableCell><strong>Class Teacher</strong></TableCell>
                          <TableCell sx={{ whiteSpace: "nowrap" }}><strong>Report</strong></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(deptClasses[dept.id] || []).map((cls) => {
                          const facultyGrouped = groupFacultyByTeacher(cls.faculty);
                          return (
                            <TableRow key={cls.classId} hover>
                              <TableCell>{cls.className}</TableCell>
                              <TableCell>{cls.section || "-"}</TableCell>
                              <TableCell align="right">{cls.studentCount}</TableCell>
                              <TableCell align="right">{cls.capacity}</TableCell>
                              <TableCell sx={{ maxWidth: 320 }}>
                                {facultyGrouped.length > 0 ? (
                                  <Box sx={{ maxHeight: 100, overflowY: "auto" }}>
                                    {facultyGrouped.map((row) => (
                                      <Box key={`${cls.classId}-${row.teacher}`} sx={{ mb: 0.5 }}>
                                        <Typography variant="caption" fontWeight={600} display="block">
                                          {row.teacher}
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary" display="block">
                                          {row.subjects.join(", ")}
                                        </Typography>
                                      </Box>
                                    ))}
                                  </Box>
                                ) : (
                                  <Typography variant="caption" color="text.secondary">—</Typography>
                                )}
                              </TableCell>
                              <TableCell>{cls.classTeacher || "—"}</TableCell>
                              <TableCell>
                                <Button size="small" variant="outlined" onClick={() => openStudentsDialog(cls)}>
                                  View
                                </Button>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                        {(deptClasses[dept.id] || []).length === 0 && (
                          <TableRow>
                            <TableCell colSpan={7} align="center">No classes in this department.</TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      )}

      {/* Students list dialog (Drill-down) */}
      <Dialog
        open={studentsDialogOpen}
        onClose={(e, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          setStudentsDialogOpen(false);
        }}
        fullWidth
        maxWidth="md"
        PaperProps={{ sx: { maxHeight: "90vh" } }}
      >
        <DialogTitle
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {`Students — ${studentsDialogClass?.className || ""}${
            studentsDialogClass?.section ? ` (${studentsDialogClass.section})` : ""
          }`}
        </DialogTitle>
        <DialogContent dividers sx={{ overflow: "hidden" }}>
          {studentsLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
              <CircularProgress size={24} />
            </Box>
          ) : (
            <>
              <TextField
                size="small"
                placeholder="Search by name or roll number…"
                value={studentsSearchQuery}
                onChange={(e) => setStudentsSearchQuery(e.target.value)}
                sx={{ mb: 1.5, width: "100%", maxWidth: 360 }}
              />
              <TableContainer sx={{ maxHeight: "calc(70vh - 220px)", overflowY: "auto" }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell><strong>Name</strong></TableCell>
                    <TableCell><strong>Roll No.</strong></TableCell>
                    <TableCell><strong>Student ID</strong></TableCell>
                    <TableCell><strong>Email</strong></TableCell>
                    <TableCell align="right" sx={{ whiteSpace: "nowrap", minWidth: 168 }}>
                      <strong>Actions</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredStudentsRows.map((s) => (
                    <TableRow key={s.id || s.studentId} hover>
                      <TableCell>{s.name || "-"}</TableCell>
                      <TableCell>{s.rollNumber || s.rollNo || "-"}</TableCell>
                      <TableCell>{s.studentId || s.id}</TableCell>
                      <TableCell>{s.email || "-"}</TableCell>
                      <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                        {/* <Button
                          size="small"
                          variant="outlined"
                          sx={{ mr: 1 }}
                          startIcon={
                            studentPreviewLoadingId === String(s.id ?? s.studentId) ? (
                              <CircularProgress size={14} />
                            ) : null
                          }
                          disabled={studentPreviewLoadingId != null}
                          onClick={() => handlePreviewStudentReport(s)}
                        >
                          View report
                        </Button> */}
                        <Button
                          size="small"
                          variant="contained"
                          sx={{ whiteSpace: "nowrap" }}
                          startIcon={
                            studentDownloadLoadingId === String(s.id ?? s.studentId) ? (
                              <CircularProgress size={14} />
                            ) : (
                              <Download />
                            )
                          }
                          disabled={studentDownloadLoadingId != null}
                          onClick={() => handleDownloadStudentReport(s)}
                        >
                          {studentDownloadLoadingId === String(s.id ?? s.studentId)
                            ? "Downloading…"
                            : "Download report"}
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                  {filteredStudentsRows.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={5} align="center">
                        No students found for this class.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setStudentsDialogOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Report preview dialog (in-app, avoids PDF UI breakage) */}
      <Dialog
        open={reportPreviewOpen}
        onClose={(e, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          setReportPreviewOpen(false);
        }}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Report preview</DialogTitle>
        <DialogContent dividers>
          {reportPreviewLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
              <CircularProgress size={24} />
            </Box>
          ) : !reportPreviewData ? (
            <Typography color="text.secondary" align="center" sx={{ py: 2 }}>
              No report data available for this student (check marks/attendance setup for selected filters).
            </Typography>
          ) : (
            <>
              <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 0.5 }}>
                {reportPreviewData.studentName} ({reportPreviewData.studentId})
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Academic year: {reportPreviewData.academicYear || "—"}
              </Typography>

              {!!reportPreviewData.dashboardStats && (
                <Card variant="outlined" sx={{ mb: 2 }}>
                  <CardContent>
                    <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
                      Dashboard stats (from API)
                    </Typography>
                    <Table size="small">
                      <TableBody>
                        <TableRow>
                          <TableCell><strong>Total hours</strong></TableCell>
                          <TableCell align="right">
                            {reportPreviewData.dashboardStats?.hours?.totalHours ?? 0}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell><strong>Total lectures</strong></TableCell>
                          <TableCell align="right">
                            {reportPreviewData.dashboardStats?.hours?.totalLectures ?? 0}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell><strong>Assignments</strong></TableCell>
                          <TableCell align="right">
                            {reportPreviewData.dashboardStats?.assignments?.totalAssignments ?? 0}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell><strong>Attendance %</strong></TableCell>
                          <TableCell align="right">
                            {reportPreviewData.dashboardStats?.attendance?.attendanceRate ??
                              reportPreviewData.dashboardStats?.attendance?.overall?.percent ??
                              0}%
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell><strong>Marked sessions</strong></TableCell>
                          <TableCell align="right">
                            {reportPreviewData.dashboardStats?.attendance?.totalMarked ?? 0}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell><strong>Present / Late / Absent</strong></TableCell>
                          <TableCell align="right">
                            {(reportPreviewData.dashboardStats?.attendance?.presentCount ?? 0)} /{" "}
                            {(reportPreviewData.dashboardStats?.attendance?.lateCount ?? 0)} /{" "}
                            {(reportPreviewData.dashboardStats?.attendance?.absentCount ?? 0)}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell><strong>Leaves</strong></TableCell>
                          <TableCell align="right">
                            {reportPreviewData.dashboardStats?.leaves?.totalRequests ?? 0}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </CardContent>
                </Card>
              )}

              {!!reportPreviewData.dashboardStats?.attendance?.subjects?.length && (
                <Card variant="outlined" sx={{ mb: 2 }}>
                  <CardContent>
                    <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
                      Subject attendance (from API)
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 1 }}>
                      This comes from <code>stats.attendance.subjects</code> on <code>/analytics/dashboard-stats</code>.
                    </Typography>
                    <TableContainer sx={{ maxHeight: 360, overflowY: "auto" }}>
                      <Table size="small" stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell><strong>Subject</strong></TableCell>
                            <TableCell align="right"><strong>Attended</strong></TableCell>
                            <TableCell align="right"><strong>Total sessions</strong></TableCell>
                            <TableCell align="right"><strong>%</strong></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {(reportPreviewData.dashboardStats.attendance.subjects || []).map((subj, idx) => (
                            <TableRow key={`${subj.subjectId ?? subj.name ?? "subj"}-${idx}`}>
                              <TableCell>{subj.name || "—"}</TableCell>
                              <TableCell align="right">{subj.attended ?? 0}</TableCell>
                              <TableCell align="right">{subj.total ?? 0}</TableCell>
                              <TableCell align="right">{subj.percent ?? 0}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                </Card>
              )}

              <Card variant="outlined" sx={{ mb: 2 }}>
                <CardContent>
                  <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
                    Personal report
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                    {reportPreviewData.personalReport?.examType || "—"} • {reportPreviewData.personalReport?.examMonth || "—"}
                  </Typography>
                  <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1, mt: 1.5 }}>
                    Report card
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                    {reportPreviewData.reportCard?.examType || "—"} • {reportPreviewData.reportCard?.examMonth || "—"} • View:{" "}
                    {reportPreviewData.reportCard?.viewFilter || "—"}
                  </Typography>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell><strong>Subject</strong></TableCell>
                        <TableCell align="right"><strong>Marks</strong></TableCell>
                        <TableCell align="right"><strong>Total</strong></TableCell>
                        <TableCell><strong>Status</strong></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(reportPreviewData.reportCard?.subjects || []).map((r, idx) => (
                        <TableRow key={`${r.subject}-${idx}`}>
                          <TableCell>{r.subject}</TableCell>
                          <TableCell align="right">{r.marksObtained ?? 0}</TableCell>
                          <TableCell align="right">{r.totalMarks ?? 0}</TableCell>
                          <TableCell>{r.status || "—"}</TableCell>
                        </TableRow>
                      ))}
                      {(reportPreviewData.reportCard?.subjects || []).length === 0 && (
                        <TableRow>
                          <TableCell colSpan={4} align="center">
                            No marks found for selected filters.
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </CardContent>
              </Card>

              <Card variant="outlined">
                <CardContent>
                  <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
                    Subject performance ({reportPreviewData.subjectPerformance?.selectedView || "monthly"})
                  </Typography>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell><strong>Subject</strong></TableCell>
                        <TableCell align="right"><strong>Attendance %</strong></TableCell>
                        <TableCell align="right"><strong>Marks %</strong></TableCell>
                        <TableCell align="right"><strong>Overall</strong></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(reportPreviewData.subjectPerformance?.subjects || []).map((s, idx) => (
                        <TableRow key={`${s.subject}-${idx}`}>
                          <TableCell>{s.subject}</TableCell>
                          <TableCell align="right">{s.attendancePercentage ?? 0}</TableCell>
                          <TableCell align="right">{s.totalMarksPercentage ?? 0}</TableCell>
                          <TableCell align="right">{s.overallPerformance ?? 0}</TableCell>
                        </TableRow>
                      ))}
                      {(reportPreviewData.subjectPerformance?.subjects || []).length === 0 && (
                        <TableRow>
                          <TableCell colSpan={4} align="center">
                            No subject performance found.
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </CardContent>
              </Card>

              <Card variant="outlined" sx={{ mt: 2 }}>
                <CardContent>
                  <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
                    Performance compression
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                    Month: {reportPreviewData.performanceCompression?.selectedMonth || "—"}
                  </Typography>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell><strong>Period</strong></TableCell>
                        <TableCell align="right"><strong>Attendance %</strong></TableCell>
                        <TableCell align="right"><strong>Total marks</strong></TableCell>
                        <TableCell align="right"><strong>Out of</strong></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {["previous", "current"].map((k) => (
                        <TableRow key={k}>
                          <TableCell sx={{ textTransform: "capitalize" }}>{k}</TableCell>
                          <TableCell align="right">{reportPreviewData.performanceCompression?.[k]?.attendancePercentage ?? 0}</TableCell>
                          <TableCell align="right">{reportPreviewData.performanceCompression?.[k]?.totalMarks ?? 0}</TableCell>
                          <TableCell align="right">{reportPreviewData.performanceCompression?.[k]?.outOf ?? 0}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </CardContent>
              </Card>

              <Card variant="outlined" sx={{ mt: 2 }}>
                <CardContent>
                  <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
                    Class compression (Yours vs Class)
                  </Typography>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell><strong>Type</strong></TableCell>
                        <TableCell align="right"><strong>Attendance %</strong></TableCell>
                        <TableCell align="right"><strong>Total marks</strong></TableCell>
                        <TableCell align="right"><strong>Out of</strong></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {["yours", "class"].map((k) => (
                        <TableRow key={k}>
                          <TableCell sx={{ textTransform: "capitalize" }}>{k}</TableCell>
                          <TableCell align="right">{reportPreviewData.classCompression?.[k]?.attendancePercentage ?? 0}</TableCell>
                          <TableCell align="right">{reportPreviewData.classCompression?.[k]?.totalMarks ?? 0}</TableCell>
                          <TableCell align="right">{reportPreviewData.classCompression?.[k]?.outOf ?? 0}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </CardContent>
              </Card>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setReportPreviewOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* ============ ADMIN / SUPER ADMIN: Attendance Heatmap ============ */}
      {showAdminDepartmentWidgets && (
        <Box sx={{ mb: 4 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <Typography variant="h6" fontWeight={600}>
              Attendance Heatmap
            </Typography>
            <FormControl size="small" sx={{ minWidth: 120 }}>
              <InputLabel>Period</InputLabel>
              <Select value={heatmapWeeks} label="Period" onChange={(e) => setHeatmapWeeks(e.target.value)}>
                <MenuItem value={4}>Last 4 weeks</MenuItem>
                <MenuItem value={8}>Last 8 weeks</MenuItem>
                <MenuItem value={12}>Last 12 weeks</MenuItem>
              </Select>
            </FormControl>
          </Box>
          {heatmapLoading ? (
            <>
              <LinearProgress sx={{ mb: 2 }} />
              <Card>
                <CardContent>
                  <Skeleton variant="rounded" height={280} />
                </CardContent>
              </Card>
            </>
          ) : heatmapData.weeks.length > 0 ? (
            <Card>
              <CardContent sx={{ p: 0, "&:last-child": { pb: 0 }, overflowX: "auto" }}>
                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600, minWidth: 150 }}>Department</TableCell>
                        {heatmapData.weeks.map((w) => (
                          <TableCell key={w} align="center" sx={{ fontWeight: 600, minWidth: 80 }}>
                            {new Date(w).toLocaleDateString(undefined, { month: "short", day: "numeric" })}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {heatmapData.departments.map((dept) => (
                        <TableRow key={dept.id} hover>
                          <TableCell sx={{ fontWeight: 500 }}>{dept.name}</TableCell>
                          {dept.weeklyRates.map((rate, i) => (
                            <MuiTooltip
                              key={i}
                              title={
                                rate !== null
                                  ? `${rate}%`
                                  : "Not enough marked attendance this week to show a rate (needs a minimum sample)."
                              }
                              arrow
                            >
                              <TableCell
                                align="center"
                                sx={{
                                  bgcolor: getHeatmapColor(rate),
                                  fontWeight: 500,
                                  transition: "background-color 0.2s",
                                }}
                              >
                                {rate !== null ? `${rate}%` : "-"}
                              </TableCell>
                            </MuiTooltip>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>
          ) : (
            <Card>
              <CardContent>
                <Typography color="text.secondary" align="center">No attendance data available for the selected period.</Typography>
              </CardContent>
            </Card>
          )}
          {/* Heatmap Legend */}
          {heatmapData.weeks.length > 0 && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 1.5, justifyContent: "flex-end" }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <Box sx={{ width: 16, height: 16, bgcolor: "#ffcdd2", borderRadius: 0.5 }} />
                <Typography variant="caption">&lt; 70%</Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <Box sx={{ width: 16, height: 16, bgcolor: "#fff9c4", borderRadius: 0.5 }} />
                <Typography variant="caption">70-85%</Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <Box sx={{ width: 16, height: 16, bgcolor: "#c8e6c9", borderRadius: 0.5 }} />
                <Typography variant="caption">&gt; 85%</Typography>
              </Box>
            </Box>
          )}
        </Box>
      )}

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <RecentActivitiesCard />
        </Grid>
      </Grid>

      <Backdrop
        open={Boolean(studentDownloadLoadingId)}
        sx={{ zIndex: (theme) => theme.zIndex.modal + 2, color: "#fff" }}
      >
        <Box sx={{ textAlign: "center" }}>
          <CircularProgress color="inherit" />
          <Typography sx={{ mt: 2 }}>Generating student report PDF…</Typography>
        </Box>
      </Backdrop>
    </Box>
  );
};
 
export default Dashboard;
 